// @flow
import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import Card from '../../../components/Card';
import { Device } from '../../../components/Responsive';
import SubmitButton from '../../../components/SubmitButton';
import BeneficiaryInformation from './BeneficiaryInformation';
import AccountInformation from './AccountInformation';
import VoidCheque from './VoidCheque';
import { handleSubmit } from './handleSubmit';
import { showSuccessModal } from '../../../modules/ModalConductor/reducer';
import { type Currency } from '../../../utilities/types';

type Props = {
  formState: string,
  setFormState: string => void,
  handleSubmit: () => void,
  voidedCheque: string,
  fileUploadDirty: boolean,
  setFileUploadDirty: boolean => void,
  submitting: boolean,
  error: ?string,
  fiatCurrencies: Currency[]
};

class BankAccountForm extends Component<Props> {
  handleEdit = () => {
    this.props.setFormState('edit');
  };

  handleClose = () => {
    this.props.setFormState('show');
  };

  handleSave = () => {
    this.props.handleSubmit();
  };

  render() {
    const editable = this.props.formState === 'show';
    const closable = this.props.formState === 'edit';
    const savable =
      this.props.formState === 'edit' || this.props.formState === 'create';

    return (
      <Card
        edit={editable}
        close={closable}
        save={savable}
        submitting={this.props.submitting}
        error={this.props.error}
        handleEdit={this.handleEdit}
        handleClose={this.handleClose}
        handleSave={this.handleSave}
      >
        <form onSubmit={this.props.handleSubmit}>
          <BeneficiaryInformation editable={editable} />
          <AccountInformation
            editable={editable}
            fiatCurrencies={this.props.fiatCurrencies}
          />
          {(this.props.formState === 'edit' ||
            this.props.formState === 'create') && (
            <>
              <VoidCheque
                setFileUploadDirty={this.props.setFileUploadDirty}
                fileUploadDirty={this.props.fileUploadDirty}
                voidedCheque={this.props.voidedCheque}
              />
              <Device>
                <SubmitButton
                  value="SAVE"
                  disabled={this.props.submitting}
                  error={this.props.error}
                  marginTop="4rem"
                />
              </Device>
            </>
          )}
        </form>
      </Card>
    );
  }
}

const onSubmitSuccess = (result, dispatch) => {
  dispatch(
    showSuccessModal(
      'Bank account information updated',
      'Your bank account information has been updated successfully.'
    )
  );
};

export default reduxForm({
  form: 'bankAccountForm',
  onSubmit: handleSubmit,
  enableReinitialize: true,
  onSubmitSuccess
})(BankAccountForm);
